var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("cargo-cloud-file-upload", {
        attrs: {
          visible: _vm.cloudFile.visible,
          job: _vm.cloudFile.job,
          "upload-source": _vm.UPLOAD_SOURCE_FILE_HISTORY.code,
          lob: _vm.cloudFile.lob,
          "job-uuids": _vm.cloudFile.jobUuids,
          "upload-to-job-uuids-sync": true,
          "tenant-instruction-uuid": _vm.tenantInstruction.uuid,
          "file-category": _vm.cloudFile.fileCategory,
          "file-category-label": _vm.cloudFile.fileCategoryLabel,
          "can-change-file-category": false
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.cloudFile, "visible", $event)
          },
          uploadSuccess: _vm.instructionCallBackByUploadFile
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }